<template>
	<div class="question-answer" :class="containerClasses">
		<div class="content" v-html="answerHtml" />

		<div class="result" v-if="showResult" :class="isCorrect ? 'result-correct' : 'result-incorrect'">
			<i class="bi bi-check-square-fill" v-if="isCorrect" />
			<i class="bi bi-x-octagon-fill" v-else />
		</div>
	</div>
</template>

<script>
	export default {
		name: 'question-answer',
		props: {
			guid: {
				type: String
			},
			answerHtml: {
				type: String
			},
			isCorrect: {
				type: Boolean,
			},
			checked: {
				type: Boolean
			},
			showResult: {
				type: Boolean
			},
		},
		computed: {
			resultCorrect() {
				return this.checked === this.isCorrect;
			},
			containerClasses() {
				let containerClasses = [];

				if (this.checked) {
					containerClasses.push('checked');
				}

				if (this.showResult) {
					if (this.resultCorrect) {
						containerClasses.push('question-answer-correct');
					} else {
						containerClasses.push('question-answer-incorrect');
					}
				}

				return containerClasses;
			}
		},
	}
</script>

<style lang="scss" scoped>
	.question-answer {
		cursor: pointer;
		padding: 10px;
		color: white;
		background-color: #8888ff;
		margin-bottom: 10px;
		position: relative;

		&.checked {
			background-color: #88ff88;
			color: black;

			font-weight: bold;
		}

		&.cannot-answer {
			cursor: default !important;
			opacity: .6;
		}

		.result {
			position: absolute;
			top: 0px;
			right: -15px;
			width: 35px;
			height: 35px;
			text-align: center;
			border-radius: 5px;
			background: rgba(255, 255, 255, 80%);
			padding: 5px;
			border: 1px solid #333333;

			&.result-correct {
				color: #00aa00;
			}

			&.result-incorrect {
				color: #aa0000;
			}
		}
	}
</style>
